import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    setTimeout(() => {
      this.dismiss()
    }, 5000)
  }

  dismiss() {
    this.element.classList.add('opacity-0', 'transition-opacity', 'duration-500')
    setTimeout(() => {
      this.element.remove()
    }, 500) // matches duration-500
  }
}
